"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetConfig_1 = require("../Model/WidgetConfig");
const WidgetState_1 = require("../Model/WidgetState");
const WidgetFacade_1 = require("../Widget/WidgetFacade");
/**
 * Primary extendables.
 */
exports.extendables = {
    widget_config: WidgetConfig_1.default,
    widget_state: WidgetState_1.WidgetState,
    widget_facade: WidgetFacade_1.default
};
